// In-call DTMF keypad (CON-155 dark restyle). Each press
// sends a single tone via the SDK (`call.sendDTMF`). Audio-
// only, but a dial pad is table stakes for IVR navigation
// mid-call. Lives in the active-call widget's "swap" slot,
// shown when the agent taps Keypad.
import { useLingui } from "@lingui/react/macro"

const KEYS: ReadonlyArray<string> = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "*",
  "0",
  "#",
]

interface DtmfPadProps {
  onTone: (tone: string) => void
}

export function DtmfPad({ onTone }: DtmfPadProps) {
  const { t } = useLingui()
  return (
    <div
      className="grid grid-cols-3 gap-2 rounded-[13px] bg-[#252019] p-3"
      role="group"
      aria-label={t`Dial pad`}
    >
      {KEYS.map((tone) => (
        <button
          key={tone}
          type="button"
          onClick={() => onTone(tone)}
          aria-label={
            tone === "*"
              ? t`Dial star`
              : tone === "#"
                ? t`Dial pound`
                : t`Dial ${tone}`
          }
          className="flex h-[38px] items-center justify-center rounded-[9px] bg-[#2F2A24] text-[17px] font-semibold leading-none text-[#FBF7F0] transition-colors hover:bg-[#3A352E] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#E0A56A]/50"
        >
          {tone}
        </button>
      ))}
    </div>
  )
}
